import React, {PropTypes} from 'react';
import {Link} from 'react-router';

import './close.css';

export const Close = ({target} = {}) => (
  <div className="close" >
    <Link className="close-icon" title="Back to home" to={target}>Close</Link>
  </div>
);

Close.displayName = 'Close';
Close.propTypes = {
  target: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/close/Close.js